import { RuledList, RuledListItem } from "@/components/shared/ruled-list";
import { FEATURES } from "../data/features";

const FeaturesPage = () => (
  <section className="mx-auto flex w-full max-w-[1280px] flex-col gap-8 px-4 pb-24 pt-14 sm:px-7">
    <h1 className="font-display text-[34px] font-medium leading-[1.05] tracking-[-0.02em] text-brand">What it does</h1>
    <div className="grid grid-cols-1 gap-x-12 lg:grid-cols-2">
      <RuledList className="lg:border-b-0">
        {FEATURES.slice(0, 3).map((f) => (
          <RuledListItem key={f.title} className="items-start py-4">
            <span className="flex flex-col gap-1">
              <span className="font-display text-xl font-medium">{f.title}</span>
              <span className="max-w-[60ch] text-[14px] text-muted-foreground">{f.description}</span>
            </span>
          </RuledListItem>
        ))}
      </RuledList>
      <RuledList className="border-t-0 lg:border-t">
        {FEATURES.slice(3).map((f) => (
          <RuledListItem key={f.title} className="items-start py-4">
            <span className="flex flex-col gap-1">
              <span className="font-display text-xl font-medium">{f.title}</span>
              <span className="max-w-[60ch] text-[14px] text-muted-foreground">{f.description}</span>
            </span>
          </RuledListItem>
        ))}
      </RuledList>
    </div>
  </section>
);

export default FeaturesPage;
